var map = {
	"./messages.ch.xlf": "../../../../raw-loader/index.js!../../../../../src/locale/messages.ch.xlf",
	"./messages.fr.xlf": "../../../../raw-loader/index.js!../../../../../src/locale/messages.fr.xlf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../../../../src/locale recursive ../../../../raw-loader/index.js!../../../../.. ^\\.\\/messages\\..*\\.xlf$";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/locale /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/raw-loader ^\.\/messages\..*\.xlf$
// module id = ../../../../../src/locale recursive ../../../../raw-loader/index.js!../../../../.. ^\.\/messages\..*\.xlf$
// module chunks = 10